/*
 * Copyright (C) 2018 Bruno López Trigo
 * 
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; either version 2
 * of the License, or (at your option) any later version.

 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.

 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 */

import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import { Tabs, Paper, Tab, Button, Typography } from "@material-ui/core";

const styles = theme => ({
  text: {
    textAlign: "center",
    fontSize: 20,
    padding: "2%",
    paddingLeft: "20%",
    paddingRight: "20%",
    maxHeight: 300,
    overflow: "auto"
  },
  bigTab: {
    display: "none",
    [theme.breakpoints.up("sm")]: {
      display: "block"
    }
  },
  smallTab: {
    display: "block",
    [theme.breakpoints.up("sm")]: {
      display: "none"
    }
  },
  tab: {
    fontSize: 16
  },
  center: {
    textAlign: "center",
  },
  panel: {
    position: "fixed",
    width: "100%",
    bottom: 100,
    left: 0
  },
  button: {
    margin: 5,
    color:"white"
  }
});

class ExplanationPanel extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      panel: 0,
      show: true
    };
    this.getExplanationNR = this.getExplanationNR.bind(this);
    this.getExplanationNC = this.getExplanationNC.bind(this);
    this.getExplanationTRL = this.getExplanationTRL.bind(this);
    this.handleChangePanel = this.handleChangePanel.bind(this);
    this.toggleExplanation = this.toggleExplanation.bind(this);
  }
  componentDidMount() {
    this.getExplanationNR();
    this.getExplanationNC();
    this.getExplanationTRL();
  }
  async getExplanationNR(){
    console.log(this.props.arrayNumberRules)
    var cci=null;
    var positionCci=null,positionNr=null;
    var nr=null;
    for(var i=0;i<this.props.arrayNumberRules.length;i++){
      if(this.props.arrayNumberRules[i].percentage>cci || cci==null){
        cci=this.props.arrayNumberRules[i].percentage
        positionCci=i;
      }
      if(this.props.arrayNumberRules[i].numberOfRules<nr || nr== null){
        nr=this.props.arrayNumberRules[i].numberOfRules
        positionNr=i;
      }else if(this.props.arrayNumberRules[i].numberOfRules===nr){
        if(this.props.arrayNumberRules[i].percentage > this.props.arrayNumberRules[positionNr].percentage){
          nr=this.props.arrayNumberRules[i].numberOfRules
          positionNr=i;
        }
      }
    }
    var phraseNR="";
    if(positionCci===positionNr){
      phraseNR="The best algorithm is "+this.props.arrayNumberRules[positionCci].algorithm.split("-")[0]+" because, with the minor number of rules has the biggest value of CCI."
    }else{
      phraseNR="The algorithm with minor number of rules is "+this.props.arrayNumberRules[positionNr].algorithm.split("-")[0]+". However, the algorithm "+this.props.arrayNumberRules[positionCci].algorithm.split("-")[0]+" has the biggest value of CCI."
    }
    this.setState({
      phraseNR:phraseNR
    })
  }
  async getExplanationNC(){
    console.log(this.props.arrayNumberConcepts)
    var cci=null;
    var positionCci=null,positionNr=null;
    var nr=null;
    for(var i=0;i<this.props.arrayNumberConcepts.length;i++){
      if(this.props.arrayNumberConcepts[i].percentage>cci || cci == null){
        cci=this.props.arrayNumberConcepts[i].percentage
        positionCci=i;
      }
      if(this.props.arrayNumberConcepts[i].numberOfRules<nr || nr == null){
        nr=this.props.arrayNumberConcepts[i].numberOfRules
        positionNr=i;
      }
    }
    var phraseNC="";
    if(positionCci===positionNr){
      phraseNC="The best algorithm is "+this.props.arrayNumberConcepts[positionCci].algorithm.split("-")[0]+" because, with the minor number of concepts has the biggest value of CCI."
    }else{
      phraseNC="The algorithm with minor number of concepts is "+this.props.arrayNumberConcepts[positionNr].algorithm.split("-")[0]+". However, the algorithm "+this.props.arrayNumberConcepts[positionCci].algorithm.split("-")[0]+" has the biggest value of CCI."
    }
    this.setState({
      phraseNC:phraseNC
    })
  }
  async getExplanationTRL(){
    console.log(this.props.arrayTrl)
    var cci=null;
    var positionCci=null,positionNr=null;
    var nr=null;
    for(var i=0;i<this.props.arrayTrl.length;i++){
      if(this.props.arrayTrl[i].percentage>cci || cci == null){
        cci=this.props.arrayTrl[i].percentage
        positionCci=i;
      }
      if(this.props.arrayTrl[i].numberOfRules<nr || nr == null){
        nr=this.props.arrayTrl[i].numberOfRules
        positionNr=i;
      }
    }
    var phraseTRL="";
    if(positionCci===positionNr){
      phraseTRL="The best algorithm is "+this.props.arrayTrl[positionCci].algorithm.split("-")[0]+" because, with the minor value of TRL has biggest value of CCI."
    }else{
      phraseTRL="The algorithm with minor value of TRL is "+this.props.arrayTrl[positionNr].algorithm.split("-")[0]+". However, the algorithm "+this.props.arrayTrl[positionCci].algorithm.split("-")[0]+" has the biggest value of CCI."
    }
    this.setState({
      phraseTRL:phraseTRL
    })
  }
  toggleExplanation() {
    this.setState(prevState => ({
      show: !prevState.show
    }));
  }

  handleChangePanel = (event, value) => {
    this.setState({ panel: value });
  };

  render() {
    console.table(this.props.checkedRules)
    console.table(this.props.checkedConcepts)
    console.table(this.props.checkedTRL)
    const { classes } = this.props;
  console.log(this.props)
    return (
      <div className={classes.center}>
        {!this.state.show && (
          <Paper className={classes.panel}>
            <Button
              variant="contained"
              color="primary"
              onClick={this.toggleExplanation}
              className={classes.button}
            >
              {
                this.props.language.labels[this.props.language.id]
                  .explanationShowButton
              }
            </Button>
          </Paper>
        )}
        {this.state.show && (
          <Paper className={classes.panel}>
            <Tabs
              className={classes.bigTab}
              value={this.state.panel}
              onChange={this.handleChangePanel}
              indicatorColor="primary"
              textColor="primary"
              centered
            >
              {this.props.checkedRules &&
              <Tab
                className={classes.tab}
                label={
                  this.props.language.labels[this.props.language.id]
                    .numberRules
                }
              />
              }
              {this.props.checkedConcepts &&
              <Tab
                  className={classes.tab}
                  label={
                    this.props.language.labels[this.props.language.id]
                        .numberConcepts
                  }
              />
              }
              {this.props.checkedTRL &&
              <Tab
                  className={classes.tab}
                  label={
                    this.props.language.labels[this.props.language.id]
                        .trl}
              />
              }
            </Tabs>
            <Tabs
              className={classes.smallTab}
              value={this.state.panel}
              onChange={this.handleChangePanel}
              indicatorColor="primary"
              textColor="primary"
              centered
            >
              {this.props.checkedRules &&
              <Tab
                  className={classes.tab}
                  label={
                    "NR"
                  }
              />
              }
              {this.props.checkedConcepts &&
              <Tab
                  className={classes.tab}
                  label={
                    "NC"
                  }
              />
              }
              {this.props.checkedTRL &&
              <Tab
                  className={classes.tab}
                  label={
                    "TRL"
                  }
              />
              }
            </Tabs>
            <Typography className={classes.text}>
              {(this.state.panel === 0 && this.state.phraseNR ) && this.props.checkedRules &&
                this.state.phraseNR
              }
              {(this.state.panel === 0 && this.state.phraseNR) && this.props.checkedConcepts && !this.props.checkedRules &&
              this.state.phraseNC
              }
              {(this.state.panel === 0 && this.state.phraseNR ) && this.props.checkedTRL && !this.props.checkedConcepts && !this.props.checkedRules &&
              this.state.phraseTRL
              }
              {this.state.panel === 1 && this.state.phraseNC && this.props.checkedConcepts &&
              this.state.phraseNC
              }
              {this.state.panel === 1 && this.state.phraseNC && !this.props.checkedConcepts && this.props.checkedTRL &&
              this.state.phraseTRL
              }
              {this.state.panel === 2 && this.state.phraseTRL &&
              this.state.phraseTRL
              }
            </Typography>
            <Button
              className={classes.button}
              variant="contained"
              color="primary"
              onClick={this.toggleExplanation}
            >
              {
                this.props.language.labels[this.props.language.id]
                  .explanationHideButton
              }
            </Button>
          </Paper>
        )}
      </div>
    );
  }
}

ExplanationPanel.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(ExplanationPanel);
